import React, {useState, useEffect} from "react";
import Modal from 'react-bootstrap/Modal';
import { alertResponseMessage } from "../../actions/action-creators/response";
import { post_api_call, error_api_call, downloadBlobCreatedFile } from "../../actions/action-creators/common";
import FormDataStuReg from "../../data/formData/student/students";
import ValidationHelper from "../../helper/validation";
import ModalMaster from "../master";
const {
    fieldStuReg,
    fieldStuRegInd,
    // oppSubsPlan,
    fieldValStuReg,
    fieldValidStuReg,
    fieldValidStuStuInd,
    oppInstituteTypes
} = FormDataStuReg;

function StuRegModal(props) {
    const [showResModal, setShowResModal] = useState(false);
    const [userData, setUserData] = useState(fieldValStuReg);
    const [isProcess, setIsProcess] = useState(false);
    const [errorData, setErrorData] = useState([]);
    const [formData, setFormData] = useState(fieldStuRegInd);
    const [regSuccessData, setRegData] = useState([]);
    const [regFailedData, setUnRegData] = useState([]);

    useEffect(() => {
        // if(props.isShow){
            setUserData(fieldValStuReg);
            setFormData(fieldStuRegInd);
            setErrorData([]);
            setIsProcess(false);
            setUnRegData([]);
            setRegData([]);
        // }
    }, [props.isShow]);// eslint-disable-line react-hooks/exhaustive-deps
    //Update Input
    const updateInput = (field, value) => {
        try{
            var updatedFormDetails = {...userData};
            updatedFormDetails[field] = value;
            if(field === "excel_file"){
                // updatedFormDetails.excel_file_data = files;
                updatedFormDetails.excel_file_data = value.files;
                updatedFormDetails.excel_file = value?.value;
            }
            setUserData({...updatedFormDetails});
            //If Country is other than India, Hide State field
            if(field === "country_id"){
                if(value.id !== 101){
                    setFormData(fieldStuReg);
                }else{
                    setFormData(fieldStuRegInd);
                }
            }
        }catch(error){
          console.log(error)
        }
    }
    const _submitForm = async(e) => {
        try{
            e.preventDefault();
            setIsProcess(true);
            setErrorData([]);
            //Validation
            const validRule = (userData.country_id
                                && typeof userData.country_id.id !== "undefined"
                                && userData.country_id.id !== 101
                            )
                                ? fieldValidStuReg
                                : fieldValidStuStuInd;
            const validation = ValidationHelper.validation(userData, validRule).error;
            if(!validation.length
                && userData.subs_from > userData.subs_to
            ){
                //Valid: Check for Subscription From and Subscription To
                validation.push(`Subscription From cannot be greater than Subscription To`);
            }
            if(validation.length){
                setErrorData(validation);
                setIsProcess(false);
                return;
            }
            var apiFormData = new FormData();
            if(typeof userData.school_id.id !== "undefined"){
                apiFormData.append('school_id', userData.school_id.id);
            }
            if(typeof userData.country_id.id !== "undefined"){
                apiFormData.append('country_id', userData.country_id.id);
                if(userData.country_id.id === 101){
                    if(typeof userData.state_id.id !== "undefined"){
                        apiFormData.append('state_id', userData.state_id.id);
                    }
                    if(typeof userData.branch_id.id !== "undefined"){
                        apiFormData.append('branch_id', userData.branch_id.id);
                    }
                }
            }
            // apiFormData.append('subs_from', userData.subs_from);
            apiFormData.append('subs_to', userData.subs_to);
            // var subsIds = [];
            // userData.subscription_id.forEach(subs_id => {
            //     if(subs_id.id === 4
            //         || subs_id.id === '4'
            //     ){//PORT+GLOSCO
            //         if(!subsIds.includes(1)){
            //             apiFormData.append('subscription_id[]', 1);
            //             subsIds.push(1);//Port
            //         }
            //         if(!subsIds.includes(5)){
            //             subsIds.push(5);//Glosco
            //             apiFormData.append('subscription_id[]', 5);
            //         }
            //     }else{
            //         if(!subsIds.includes(subs_id.id)){
            //             subsIds.push(subs_id.id);
            //             apiFormData.append('subscription_id[]', subs_id.id);
            //         }
            //     }
            // });
            // apiFormData.append('subscription_id[]', subsIds);
            if(typeof userData.institute_type_id.id !== "undefined"){
                apiFormData.append('institute_type_id', userData.institute_type_id.id);
            }
            apiFormData.append('excel_file', userData.excel_file_data[0]);
            // console.log(userData, 'userDatauserDatauserDatauserData')
            const apiData = await post_api_call(`student/create`, apiFormData);
            // console.log(apiData, 'apiDataapiDataapiDataapiData')
            if(apiData.status === 200){
                alertResponseMessage({alert_type: apiData.failed_data.length ? 2 : 1, message: apiData.message});
                // Show Not Registered & Registered Data
                if(apiData.success_data.length > 0){
                    setRegData(apiData.success_data);
                    props._resetListing();
                }
                if(apiData.failed_data.length > 0){
                    setUnRegData(apiData.failed_data);
                    //automatically download data in Excel File
                    const apiExcelData = await post_api_call('sample/registration', {data: apiData.excel_data}, true, 'blob');
                    if(apiExcelData.status === 200){
                        downloadBlobCreatedFile(apiExcelData, `Failed-Registration-Data.xlsx`);
                        // // Create a Blob URL
                        // const url = window.URL.createObjectURL(new Blob([apiExcelData]));
                        // // Create a temporary <a> to trigger download
                        // const link = document.createElement('a');
                        // link.href = url;
                        // const currentTime = new Date().toLocaleString().replace(',','').replace(' ','');
                        // link.setAttribute('download', `Failed-Registration-Data-${currentTime}.xlsx`);
                        // document.body.appendChild(link);
                        // link.click();
                        // // Clean up
                        // link.remove();
                        // window.URL.revokeObjectURL(url);
                    }
                }
                setShowResModal(true);
                // props._toggleModal(e, false);
            }else{
                // The API refused the file (for example a sheet from the old template): show the reason inside this modal,
                // the toast alone can be missed behind it.
                setErrorData([apiData?.message || 'The file could not be processed. Please try again.']);
            }
            setIsProcess(false);
        }catch(error){
            setIsProcess(false);
            console.error(error);
            alertResponseMessage({alert_type: 2, message: "Error Registering! Please try after some times"});
            error_api_call({error: `modal/student/registration|_submitForm|${e}`});
        }
    }

    return (
      <>
        {(regFailedData.length > 0
            || regSuccessData.length > 0
        ) 
        ?
            <>
                <Modal dialogClassName="modal-70w modal-dialog-scrollable" show={showResModal} onHide={(e) => {setShowResModal(false); props._toggleModal(e, false);}} size="md" className="mod-custom team-detail" backdrop="static">
                    <Modal.Header closeButton>Excel Upload Result</Modal.Header>
                    <Modal.Body>
                        {/* Failed Data */}
                        {regFailedData.length > 0 && (
                            <fieldset>
                                <legend>Failed Registration Data ({regFailedData.length})</legend>
                                <div className={`row m-0 table-responsive table table-danger ${regSuccessData.length > 0 ? 'scroll-div-30vh' : ''}`}>
                                    <table className="table-bordered">
                                        <thead className="table-secondary">
                                            <tr>
                                                <th>Excel Row No.</th>
                                                <th>Reason</th>
                                                <th>Subscription Plan</th>
                                                <th>Glosco Year/Level</th>
<th>ESG Level</th>
                                                <th>Name</th>
                                                <th>DOB(DD/MM/YYYY)</th>
                                                <th>Email</th>
                                                <th>Class</th>
                                                <th>City</th>
                                                <th>Phone Code</th>
                                                <th>Phone Number</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {regFailedData.map((fail_data, fail_idx) => (
                                                <tr key={`failed_data_${fail_idx}`}>
                                                    <td>{fail_data.row_no}</td>
                                                    <td><b>{fail_data.reason}</b></td>
                                                    {fail_data.data.map((fail_stu_d, fail_stu_idx) => (
                                                        <td key={`fail_stu_${fail_stu_idx}`}>{fail_stu_d}</td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </fieldset>
                        )}
                        {/* Success Data */}
                        {regSuccessData.length > 0 && (
                            <fieldset>
                                <legend>Registered Users ({regSuccessData.length})</legend>
                                <div className={`row m-0 table-responsive table table-success ${regFailedData.length > 0 ? 'scroll-div-30vh' : ''}`}>
                                    <table className="table-bordered">
                                        <thead className="table-secondary">
                                            <tr>
                                                <th>Excel Row No.</th>
                                                <th>Password</th>
                                                <th>Subscription Plan</th>
                                                <th>Glosco Year/Level</th>
<th>ESG Level</th>
                                                <th>Name</th>
                                                <th>DOB(DD/MM/YYYY)</th>
                                                <th>Email</th>
                                                <th>Class</th>
                                                <th>City</th>
                                                <th>Phone Code</th>
                                                <th>Phone Number</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {regSuccessData.map((succ_data, succ_idx) => (
                                                <tr key={`success_data_${succ_idx}`}>
                                                    <td>{succ_data.row_no}</td>
                                                    <td><b>{succ_data.password}</b></td>
                                                    {succ_data.data.map((succ_stu_d, succ_stu_idx) => (
                                                        <td key={`succ_stu_${succ_stu_idx}`}>{succ_stu_d}</td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </fieldset>
                        )}
                    </Modal.Body>
                    <Modal.Footer className="team-detail">
                        <button className="btn btn-secondary" onClick={(e) => {setShowResModal(false); props._toggleModal(e, false);}}>Close</button>
                    </Modal.Footer>
                </Modal>
            </>
        :
        <ModalMaster
            isShow={props.isShow}
            _toggleModal={(e, state) => props._toggleModal(e, state)}
            // modKey={activeEditForm}//new, edit
            formType={'excel_reg'}
            data={userData}
            title={"Student Registration"}
            _errorData={{excel_reg: errorData}}
            _isProcess={{excel_reg: isProcess}}
            _updateInput= {(form_type, variable_type, input_type, field, value) => updateInput(field, value)}
            // _updateInput= {(form_type, variable_type, input_type, field, value, files="") => updateInput(field, value, files)}
            _submitForm={(e, form_type) => _submitForm(e)}
            _formData={[{form_type: 'excel_reg', label: 'Details', fields: [...formData]}]}
            selectOptions={{...props.selectOptions,
                        // subscription_id: {value: 'id',
                        //                 label: 'service',
                        //                 data: [...oppSubsPlan]},
                        institute_type_id: {value: 'id',
                                        label: 'type',
                                        data: [...oppInstituteTypes]},
                    }}    
        />
        }
      </>
    );
}
  
export default StuRegModal;